import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { PageProjectTimeReport } from "@components/modules/projects/time-report/PageProjectTimeReport";
import { NavigationProjects } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Time report`}
    navigation={<NavigationProjects projectId={id} />}
    scrollToTopButton
  >
    <PageProjectTimeReport />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/projects/time-report")({
  component: RouteComponent,
});
